import React from "react";
import { Navigate, Route } from "react-router-dom";
import useGettingLoginData from "../hooks/useGettingLoginData";

const B2BRoute = ({ element: Component, visibility = 'private' }) => {
    const loginData = useGettingLoginData();    
    return visibility === 'private' ? loginData ? Component : <Navigate to="/login" /> : Component;
}

export const useB2BRoute = (routes) => {
    return routes.map(route => (
        <Route
            key={route.path}
            path={route.path}
            element={<B2BRoute element={route.element} visibility={route.visibility} />}
            visibility={route.visibility}
        />
    ));
};

export default B2BRoute;